<template>
<div class="timeline-entry timeline-entry-universal-flow">
    <div class="row pr-3">
        <div class="col line-section pr-0 profile-image-sm-width-flex d-flex flex-column align-items-center">
            <div class="line line-pre mb-1"></div>
            <div class="img-container">
              <img class="profile-image-sm rounded-circle shadow lg" :src="activity.activityDetail.from.avatarPath" />
            </div>
            <div class="line flex-grow-1 mt-1"></div>
        </div>
        <div class="col detail-part pt-2 pl-2 border-bottom">
            <div class="pt-2 pb-3 pl-2 pr-2">
                <p class="font-weight-normal m-0">{{activity.activityDetail.from.name}}<small class="ml-1 text-secondary">{{text}} <span v-if="activity.activityDetail.contractNo !== null">#{{activity.activityDetail.contractNo}}</span></small></p>
                <p class="m-0 text-secondary font-weight-lighter"><small>{{$dayjs(activity.datetime).fromNow()}}</small></p>
            </div>
            <div class="card p-3 mb-4 shadow">
                <div class="row">
                    <div class="col">
                        <p class="h3 m-0">{{ moneyDisplay[0] }}<span class="h6">.{{ moneyDisplay[1] }}</span></p>
                        <p class="text-secondary m-0"><small>แบ่งชำระ {{activity.activityDetail.moneyPayload.duration}} งวด ดอกเบี้ย {{ $big(activity.activityDetail.moneyPayload.interest).times(100) }}%</small></p>
                    </div>
                    <div class="col-sm-6 d-flex align-items-center">
                      <button class="btn btn-primary btn-block rounded-pill" @click="navigate()"><small>รายละเอียด</small></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  computed: {
    moneyDisplay () {
      const formatted = this.$currency(this.activity.activityDetail.moneyPayload.amount).format().split('.')
      return formatted
    }
  },
  methods: {
    navigate () {
      window.location.assign(`${window.BASE_URL}member/transaction-contract#/view/${this.activity.activityDetail.contractId}`)
    }
  },
  props: ['activity', 'text']
}
</script>

<style lang="scss">
</style>
